module.exports = __webpack_public_path__ + "static/media/nusclearlabjiaming2.0dcff560.jpeg";